<template>
	<div class="learning-container" aria-label="当前为学习页面，选项卡部分包括课程视频、教具制作视频和学习文档三部分，您可以选中对应选项卡打开相应资源。课程视频讲解了本节的知识，教具制作视频讲解了本节所需教具的制作方法，学习文档提供的本节配套的文本资料。如果您在学习的过程中有疑问，可点击页面顶部的AI助教按钮，这将跳转到AI聊天界面。" tabindex="0">
		<div class="navbar1">
			<BackButton class="back-button"/>
			<GetAIButton style="width: 20%; height: 100%" />
		</div>
		<div class="tabs">
			<div
				:class="['tab', {active: activeTab === 'courseVideo'}]"
				@click="handleTab('courseVideo')"
				@keydown.enter="handleTab('courseVideo')"
				role="tab"
				:aria-label="(activeTab === 'courseVideo' ? '已选中 ' : '') + '课程视频'"
				tabindex="0"
			>课程视频</div>
			<div
				:class="['tab', {active: activeTab === 'aidVideo'}]"
				@click="handleTab('aidVideo')"
				@keydown.enter="handleTab('aidVideo')"
				role="tab"
				:aria-label="(activeTab === 'aidVideo' ? '已选中 ' : '') + '教具制作视频'"
				tabindex="0"
			>教具制作视频</div>
			<div
				:class="['tab', {active: activeTab === 'document'}]"
				@click="handleTab('document')"
				@keydown.enter="handleTab('document')"
				role="tab"
				:aria-label="(activeTab === 'document' ? '已选中 ' : '') + '学习文档'"
				tabindex="0"
			>学习文档</div>
		</div>
		<div class="learning-area">
			<keep-alive>
				<HlsPlayer v-if="activeTab === 'courseVideo' && sectionInfo.courseVideoUrl !== ''" :url="baseUrl + sectionInfo.courseVideoUrl" ></HlsPlayer>
			</keep-alive>
			<p v-if="activeTab === 'courseVideo' && sectionInfo.courseVideoUrl === ''" tabindex="0" style="margin-top: 100%">暂无相关资源</p>
			<keep-alive>
				<HlsPlayer v-if="activeTab === 'aidVideo' && sectionInfo.aidVideoUrl !== ''" :url="baseUrl + sectionInfo.aidVideoUrl" ></HlsPlayer>
			</keep-alive>
			<p v-if="activeTab === 'aidVideo' && sectionInfo.aidVideoUrl === ''" tabindex="0" style="margin-top: 100%">暂无相关资源</p>
			<div v-if="activeTab == 'document' && sectionInfo.documentUrl !== ''" v-html="this.document" tabindex="0"></div>
			<p v-if="activeTab === 'document' && sectionInfo.documentUrl === ''" tabindex="0" style="margin-top: 100%">暂无相关资源</p>		</div>
	</div>
</template>

<script>
	import BackButton from '@/components/BackButton.vue';
	import GetAIButton from '@/components/GetAIButton.vue';
import mammoth from 'mammoth';
import HlsPlayer from '@/components/HlsPlayer.vue';
import { baseUrl} from '@/constants/urls.js';

	export default{
		data(){
			return {
				baseUrl: baseUrl,
				sectionInfo: JSON.parse(this.$route.query.sectionInfo),
				document: '',
				activeTab: 'courseVideo'
			}
		},
		components: {BackButton, GetAIButton, HlsPlayer},
		methods: {
			handleTab(tag){
				this.activeTab=tag;
				if (this.activeTab === 'document') {
					this.getDocument();
				}
			},
			async getDocument() {
				try {
					const response = await fetch(this.baseUrl+this.sectionInfo.documentUrl);
					if (!response.ok) throw new Error("文件下载失败");
					const blob = await response.blob();
					const reader = new FileReader();
					reader.readAsArrayBuffer(blob);
					reader.onload = async (event) => {
						const arrayBuffer = event.target.result;
						const document = await mammoth.convertToHtml({ arrayBuffer });
						this.document=document.value;
					};
				} catch (error) {
					console.error("Error loading DOCX:", error);
				}
			}
		}
	}
</script>

<style scoped>
.learning-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 50%;
	margin: 0 auto; /* ⬅️ 让整个容器水平居中 */
}

.navbar1{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	height: 40px;
	margin-top: 10vh;
}

.back-button {
	width: 20%;
	height: 100%;
}

.tabs{
	display: flex;
	flex-direction: row;
	width:70%;
	height: 40px;
	margin-top: 40px;
}

.tab {
	display: flex; /* 让 .tab 成为 flex 容器 */
	justify-content: center; /* 水平居中 */
	align-items: center; /* 垂直居中 */
	flex: 1; /* 平均分配宽度 */
	text-align: center;
	padding: 10px;
	border: 1px solid #ccc; /* 边框 */
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.active{
	background: linear-gradient(to bottom, rgb(100, 255, 100), rgb(204, 255, 204));
	color: #006400;
	font-weight: bold;
}

@media (max-width: 500px){
	.learning-container{
		width: 100%;
	}

	.navbar1 {
		margin-top: 10vh;
	}

	.back-button {
		width: 30%;
		font-size: 90%;
	}

	.tabs {
		width: 100%;
	}

	.tab {
		font-size: 90%;
	}
}

</style>